<div class="pinned toolbar-wraps">
  <div class="title">
    <nb-tabset fullWidth (changeTab)="onTab($event)">
      @for (tab of tabs; track tab.filter) {
        <nb-tab [tabId]="tab.filter" [tabTitle]="tab.title" [active]="tab.filter === filter"></nb-tab>
      }
    </nb-tabset>
  </div>
  <div class="buttons">
    <div class="search-input">
      <nb-icon class="search-icon" icon="search-outline"></nb-icon>
      <input nbInput
        type="text"
        [placeholder]="'intake.list.search' | translate"
        [attr.aria-label]="'intake.list.search' | translate"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange($event)"
        fieldSize="small">
      @if (searchQuery) {
        <nb-icon class="clear-icon" icon="close-circle" (click)="clearSearch()"></nb-icon>
      }
    </div>
    <bst-table-options-button class="desktop-only" [count]="0" (open)="events.next(DualAxisEvent.OPENCOLUMNS)"></bst-table-options-button>
  </div>
  <!-- The address only matters until mail arrives; after that it lives in My company. -->
  @if (noMailYet) {
    <bst-intake-address-block mode="strip" class="address-strip"></bst-intake-address-block>
  }
</div>

<bst-dual-axis [tag]="'intake_mails'" [delegate]="this" [experimentalGrid]="true" [fitWidth]="true"></bst-dual-axis>

<ng-template #cellTemplate let-row="row" let-column="column">
  @switch (column.name) {
    @case ('received_at') {
      <span class="when">{{ row.received_at | intakeDate: 'dayTime' }}</span>
    }
    @case ('subject') {
      <a class="subject" [routerLink]="['/market/intake', row.id]" [title]="row.subject || ''">
        @if (contentGone(row) && !row.subject) {
          <em>{{ 'intake.list.content_removed' | translate }}</em>
        } @else {
          {{ row.subject || ('intake.list.no_subject' | translate) }}
        }
      </a>
    }
    @case ('sender') {
      <span class="sender" [title]="row.sender || ''">{{ row.sender || '-' }}</span>
    }
    @case ('verdict') {
      <span class="badge-wrapper"><nb-badge [text]="verdictKey(row) | translate" [status]="verdictStatus(row)"></nb-badge></span>
    }
    @case ('reason') {
      @if (reasonKey(row); as key) {
        <span class="reason" [title]="key | translate">{{ key | translate }}</span>
      } @else if (row.vacancy?.title) {
        <span class="reason" [title]="row.vacancy.title">{{ row.vacancy.title }}</span>
      }
    }
  }
</ng-template>

<ng-template #cardTemplate let-row="row">
  <a class="intake-card" [routerLink]="['/market/intake', row.id]">
    <div class="top">
      <span class="badge-wrapper"><nb-badge [text]="verdictKey(row) | translate" [status]="verdictStatus(row)"></nb-badge></span>
      <span class="when">{{ row.received_at | intakeDate: 'dayTime' }}</span>
    </div>
    <div class="subject">
      @if (contentGone(row) && !row.subject) {
        <em>{{ 'intake.list.content_removed' | translate }}</em>
      } @else {
        {{ row.subject || ('intake.list.no_subject' | translate) }}
      }
    </div>
    <div class="sender">{{ row.sender || '-' }}</div>
    @if (reasonKey(row); as key) {
      <div class="reason">{{ key | translate }}</div>
    } @else if (row.vacancy?.title) {
      <div class="reason">{{ row.vacancy.title }}</div>
    }
  </a>
</ng-template>
